import type { CartState } from './cart';
import { toLineRequests } from './documents';
import type { DocumentHeader } from './editorSchema';
import { effectiveDiscount } from './totals';

/** What the invoice / order editor submits. */
export interface EditorValues {
  header: DocumentHeader & { contact: { id: string; name: string } };
  cart: CartState;
}

/** Body for POST /sales-invoices from the editor (an invoice without an order). */
export function toInvoiceRequest(values: EditorValues, id: string) {
  const { header, cart } = values;
  const discount = effectiveDiscount(cart.discount);
  return {
    id,
    contactId: header.contact.id,
    docDate: header.docDate,
    ...(header.later ? { dueDate: header.later } : {}),
    ...(discount ? { discount } : {}),
    reference: header.reference.trim() || null,
    notes: header.notes.trim() || null,
    lines: toLineRequests(cart),
  };
}

/** Body for POST /sales-orders (and, without id/confirm, PATCH). */
export function toOrderRequest(values: EditorValues) {
  const { header, cart } = values;
  const discount = effectiveDiscount(cart.discount);
  return {
    contactId: header.contact.id,
    docDate: header.docDate,
    expectedDate: header.later || null,
    ...(header.locationId ? { locationId: header.locationId } : {}),
    discount: discount ?? null,
    reference: header.reference.trim() || null,
    notes: header.notes.trim() || null,
    lines: toLineRequests(cart),
  };
}
